import type { ComponentProps } from 'react';
import Exchange from '@ui/features/Exchange';
import { useUserRedeemRequests } from './executors/hooks/useUserRedeemRequests';

type ExchangeContextProps = ComponentProps<typeof Exchange.Context>;

/**
 * Exchange.Context wrapper for Standard Redeem that refetches user requests
 * when a redeem tx is confirmed.
 */
export const StandardRedeemContext = (props: ExchangeContextProps) => {
  const { refetch } = useUserRedeemRequests();
  return <Exchange.Context {...props} onSwapSuccess={refetch} />;
};
